import { Dispatch, SetStateAction } from "react";
import SessionsApi from "../../../../../../../api/sessionApi";
import Notify from "../../../../../../../utils/toaster";
import { NewPackageType } from "./PackagesTool";

const uploadPackageVideoPartially = async (
  language: string,
  video: File,
  token: string,
  setProgress: Dispatch<
    SetStateAction<
      | {
          totalSize: number;
          uplaodedSize: number;
        }
      | undefined
    >
  >,
  packageId: string
) => {
  return await new Promise(async (resolve) => {
    const chunkSize = 1 * 1024 * 1024; // 5MB
    let offset = 0;
    setProgress((prev) => {
      if (prev) {
        return { ...prev, totalSize: prev.totalSize + video.size };
      }
      return { totalSize: video.size, uplaodedSize: 0 };
    });
    while (offset < video.size) {
      const chunk = video.slice(offset, offset + chunkSize);
      const formData = new FormData();
      formData.append("file", chunk);
      formData.append("language", language);
      formData.append("originalname", video.name);
      formData.append("offset", offset.toString());
      setProgress((prev) => {
        if (prev) {
          return { ...prev, uplaodedSize: prev.uplaodedSize + chunkSize };
        }
        return { uplaodedSize: chunkSize, totalSize: video.size };
      });
      try {
        await SessionsApi.uploadPackageVideoPartially(
          token,
          formData,
          packageId
        );
      } catch (error) {
        console.error(error);
      }

      offset += chunkSize;
    }
    await SessionsApi.finishPackageVideoUpload(
      { language, originalname: video.name, packageId, returnPackage: false },
      token
    ).then((response) => {
      if (!response.status && response.message) {
        Notify(response.message);
      }
    });
    setTimeout(() => {
      resolve({ status: true, message: undefined });
    }, 2000);
  });
};
export const packageVideoUpload = async (
  filesData: { language: string; video: File }[],
  token: string,
  setProgress: Dispatch<
    SetStateAction<
      | {
          totalSize: number;
          uplaodedSize: number;
        }
      | undefined
    >
  >,
  packageId: string
) => {
  const uploadVideosToBucketPromise = filesData.map((item) => {
    return uploadPackageVideoPartially(
      item.language,
      item.video,
      token,
      setProgress,
      packageId
    );
  });

  await Promise.all(uploadVideosToBucketPromise);

  /*  const payload = {
      specialistId: specialistId,
      files: uploadResult.map((res) => ({
        language: res.language!,
        video: res.video!,
      })),
    };
    const response = await SpecialistApi.uploadIntroVideo(payload, token); */
  return { status: true };
};
export const onDrop = (
  event: {
    event: { oldIndex: number; newIndex: number };
    list: any[];
  },
  setNewPackageData: Dispatch<SetStateAction<NewPackageType>>
) => {
  const items = event.list.map((item, index) => ({
    ...item,
    order: index + 1,
  }));

  setNewPackageData((prev) => ({ ...prev, sessions: items }));
};
const isValidMultiLangFields = (
  arr: { language: string; text: string }[][]
) => {
  return arr.flat().every((item) => item.text?.trim().length > 0);
};
export const validatePackageFields = (newPackageData: NewPackageType) => {
  if (
    !newPackageData.sessions.every((session) => !!session.specialization) ||
    !newPackageData.sessions.length ||
    !newPackageData.specializations.length ||
    !newPackageData.directions.length ||
    !isValidMultiLangFields([
      newPackageData.description,
      newPackageData.title,
      ...newPackageData.sessions.map((item) => item.title),
      /*    ...newPackageData.sessions.map(
        (item) => item.description ?? item.title
      ), */
    ])
  )
    return false;
  return true;
};
export const hasMissingFields = (
  language: string,
  newPackageData: NewPackageType
): boolean => {
  const checkField = (field?: { text: string; language: string }[]) =>
    !field?.some(
      (item) => item.language === language && item.text.trim().length > 0
    );

  if (
    checkField(newPackageData.title) ||
    checkField(newPackageData.description)
  ) {
    return true;
  }

  for (const session of newPackageData.sessions) {
    if (checkField(session.title)) {
      return true;
    }
  }

  return false;
};

export const validateInput = (
  selectedLang: string | undefined,
  text:
    | {
        text: string;
        language: string;
      }[]
    | undefined
) => {
  if (!text) return false;
  const currentText = text
    .find((el) => el.language === selectedLang)
    ?.text.trim();
  if (!currentText || !currentText.length) return true;
  return false;
};

export const truncateString = (str: string, num: number) => {
  if (str.length <= num) {
    return str;
  }

  const half = Math.floor(num / 2);
  const start = str.slice(0, half);
  const end = str.slice(str.length - half);

  return `${start}...${end}`;
};
